import React from "react";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom"; //HashRouter,
import {
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import "normalize.css/normalize.css";
import "@blueprintjs/core/lib/css/blueprint.css";
import "./survey-ui/styles/setproduct.css";
import './survey-ui/styles/custom-style.css';
import './survey-ui/styles/custom-responsive.css';
import 'react-toastify/dist/ReactToastify.css';

import Login from "./survey-ui/views/pages/Authentication/login/Login";
import ForgotPassword from "./survey-ui/views/pages/Authentication/forgot-password/ForgotPassword";
import ForgetPasswordConfirmation from "./survey-ui/views/pages/Authentication/forgot-password/ForgetPasswordConfirmation";
import ResetPassword from "./survey-ui/views/pages/Authentication/forgot-password/ResetPassword";
import PasswordChanged from "./survey-ui/views/pages/Authentication/forgot-password/PasswordChanged";
import SignUp from "./survey-ui/views/pages/Authentication/sign-up/SignUp";
import EmailVerification from "./survey-ui/views/pages/Authentication/sign-up/EmailVerification";
import LoginOtpVerification from "./survey-ui/views/pages/Authentication/login/EmailVerification";
import AccountSetUp from "./survey-ui/views/pages/Authentication/sign-up/AccountSetUp";
import AccountSetUpGl from "./survey-ui/views/pages/Authentication/sign-up/AccountSetUpGl";
import OnBoardingScreen from "./survey-ui/views/pages/Authentication/sign-up/OnBoardingScreen";
import ProcessDone from "./survey-ui/views/pages/Authentication/sign-up/ProcessDone";
import TeamAccountSetUp from "./survey-ui/views/pages/Authentication/team-invitation/AccountSetUp";
import TeamVerification from "./survey-ui/views/pages/Authentication/team-invitation/TeamVerification";

import TeamOnBoardingScreen from "./survey-ui/views/pages/Authentication/team-invitation/OnBoardingScreen";
import TeamProcessDone from "./survey-ui/views/pages/Authentication/sign-up/ProcessDone";
import InvitationEmail from "./survey-ui/views/pages/Authentication/team-invitation/InvitationEmail";
import JoinExistingAccount from "./survey-ui/views/pages/Authentication/team-invitation/JoinExistingAccount";
import AccountSetUpSignUp from "./survey-ui/views/pages/Authentication/team-invitation/AccountSetUpSignUp";
import JoiningRequestExistingAccount from "./survey-ui/views/pages/Authentication/team-invitation/JoiningRequestExistingAccount";
import Profile from "./survey-ui/views/pages/settings/Profile";
import UserRoles from "./survey-ui/views/pages/settings/UserRoles";
import UserPermissions from "./survey-ui/views/pages/settings/UserPermissions";
import Teams from "./survey-ui/views/pages/settings/teams/Teams";
import CreateTeam from "./survey-ui/views/pages/settings/teams/Create";
import EditTeam from "./survey-ui/views/pages/settings/teams/Edit";
import Notifications from "./survey-ui/views/pages/settings/Notifications";
import Aws from "./survey-ui/views/pages/settings/Aws";
import Smtp from "./survey-ui/views/pages/settings/Smtp";
import Puppeteer from "./survey-ui/views/pages/settings/Puppeteer"
import TeamInvitation from "./survey-ui/views/pages/Authentication/team-invitation/Index";
import Terms from "./survey-ui/views/pages/survey/survey-form/content-pages/Terms";
import PrivacyPolicies from "./survey-ui/views/pages/survey/survey-form/content-pages/PrivacyPolicies";


import { PersistGate } from 'redux-persist/integration/react'
import { Provider, useDispatch } from 'react-redux';
import store, { persistor } from "./survey-ui/store/store";
import { useEffect } from "react";
import { SET_SURVEY_ID, SET_SURVEY_NAME } from "./survey-ui/store/constant";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

// import ROIComponents from "./survey-ui/views/pages/roi-calculator/ROIComponents";
// import ROIForm from "./survey-ui/views/pages/roi-calculator/ROIForm";
import CookiePolicies from "./survey-ui/views/pages/survey/survey-form/content-pages/CookiePolicies";
import NotFound from "./survey-ui/views/pages/404/NotFound";
import ROIReport from "./survey-ui/views/pages/roi-calculator/ROIReport";
import ContactUs from "./survey-ui/views/pages/survey/survey-form/content-pages/ContactUs";
// import ROISinglePage from "./survey-ui/views/pages/roi-calculator/ROISinglePage";
import RoiUpdate from "./survey-ui/views/pages/roi-calculator/ROITemplates";
import OnBoarding from "./survey-ui/views/pages/roi-calculator/OnBoarding";
import RoiCalculation from "./survey-ui/views/pages/roi-calculator/RoiCalculation";
import RoiCalculationAdd from "./survey-ui/views/pages/roi-calculator/RoiCalculationAdd";
import RoiCustomVariable from "./survey-ui/views/pages/roi-calculator/RoiCustomVariable";
import RoiCustomVariableAdd from "./survey-ui/views/pages/roi-calculator/RoiCustomVariableAdd";
// import TemplateList from "./survey-ui/views/pages/roi-calculator/TemplateList";
import RoiCreate from "./survey-ui/views/pages/roi-calculator/CreateTemplate";
import ROIAnalytics from "./survey-ui/views/pages/roi-calculator/ROIAnalytics";
// import EditorComponent from "./survey-ui/views/pages/roi-calculator/components/ConditionalLogicModal";


import DocumentationSidebar from "./survey-ui/views/pages/documentation/component/DocumentationSidebar";
import CreateCalculator from "./survey-ui/views/pages/documentation/surveys/CreateCalculator";
import DocumentDashboard from "./survey-ui/views/pages/documentation/surveys/Dashboard";
import ActionInCalculatorList from "./survey-ui/views/pages/documentation/surveys/ActionInCalculatorList";
import CalculationLogic from "./survey-ui/views/pages/documentation/surveys/CalculationLogic";
import CustomVariable from "./survey-ui/views/pages/documentation/surveys/CustomVariable";
import DocumentAccountSetting from "./survey-ui/views/pages/documentation/settings/AccountSetting";
import DocumentPuppeteerSettings from "./survey-ui/views/pages/documentation/settings/PuppeteerSettings";
import DocumentRoles from "./survey-ui/views/pages/documentation/settings/Roles";
import DocumentTeams from "./survey-ui/views/pages/documentation/settings/Teams";
import DocumentUsers from "./survey-ui/views/pages/documentation/settings/Users";
import DocumentAnalytics from "./survey-ui/views/pages/documentation/Analytics";


window.product = 'P1';

if (window.product === 'P1') {
  window.modulePermissions =
  {
    "M1": { "name": "Assessments", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M2": { "name": "Analytics", "view": 0 },
    "M3": { "name": "Users", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M4": { "name": "Roles", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M5": { "name": "Teams", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M10": { "name": "SuperAdmin", "view": 0, "add": 0, "edit": 0, "del": 0 }
  };

}


if (window.product === 'P2') {
  window.modulePermissions =
  {
    "M3": { "name": "Users", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M4": { "name": "Roles", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M5": { "name": "Teams", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M6": { "name": "Knowledge Hub", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M7": { "name": "Prompts", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M8": { "name": "AI Assistants", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M9": { "name": "Videos", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M10": { "name": "Languages", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M11": { "name": "Workflows", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M12": { "name": "3D", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M13": { "name": "2D", "view": 0, "add": 0, "edit": 0, "del": 0 },
    "M14": { "name": "Frontend Portals", "view": 0, "add": 0, "edit": 0, "del": 0 },
  };

}



const App = () => {

  const location = useLocation();
  const dispatch = useDispatch()

  //SurveyId remover
  useEffect(() => {
    if (location) {
      const [_, first, second, ...other] = location.pathname?.split('/')
      if (first === 'admin' && second === 'survey' && location.pathname !== '/admin/survey/list') {
        // console.log('-----', first, second)
      } else {
        dispatch({ type: SET_SURVEY_ID, payload: '' })
        dispatch({ type: SET_SURVEY_NAME, payload: null })
      }
    }
  }, [location])


  return (
    <>
      <ToastContainer />
      <PersistGate loading={null} persistor={persistor}>
        <Routes>
          <Route exact path="/" element={<Login />}> </Route>
          <Route exact path="/admin/login" element={<Login />} />
          <Route exact path="/admin/forgot-password" element={<ForgotPassword />}> </Route>
          <Route exact path="/admin/forgot-password/confirmation" element={<ForgetPasswordConfirmation />}> </Route>
          <Route exact path="/admin/reset-password" element={<ResetPassword />}> </Route>
          <Route exact path="/admin/password-changed" element={<PasswordChanged />}> </Route>
          <Route exact path="/admin/signup" element={<SignUp />}> </Route>
          <Route exact path="/EmailVerification" element={<EmailVerification />}> </Route>
          <Route exact path="/team-verification" element={<TeamVerification />}> </Route>
          <Route exact path="/admin/email-verification" element={<LoginOtpVerification />}> </Route>
          <Route exact path="/admin/contact-us" element={<ContactUs />}> </Route>
          {/* To Be Removed  */}
          <Route exact path="/AccountSetUp" element={<AccountSetUp />}> </Route>
          <Route exact path="/AccountSetUpGl" element={<AccountSetUpGl />}> </Route>
          <Route exact path="/OnBoardingScreen" element={<OnBoardingScreen />}> </Route>
          <Route exact path="/ProcessDone" element={<ProcessDone />}> </Route>
          <Route exact path="/InvitationEmail" element={<InvitationEmail />}> </Route>
          <Route exact path="/team-invitation" element={<TeamInvitation />}> </Route>
          <Route exact path="/TeamAccountSetUp" element={<TeamAccountSetUp />}> </Route>
          <Route exact path="/TeamOnBoardingScreen" element={<TeamOnBoardingScreen />}> </Route>
          <Route exact path="/TeamProcessDone" element={<TeamProcessDone />}> </Route>
          <Route exact path="/JoinExistingAccount" element={<JoinExistingAccount />}> </Route>
          <Route exact path="/AccountSetUpSignUp" element={<AccountSetUpSignUp />}> </Route>
          <Route exact path="/JoiningRequestExistingAccount" element={<JoiningRequestExistingAccount />}> </Route>


          <Route exact path="/admin/settings/profile" element={<Profile />} />
          <Route exact path="/admin/settings/user-roles" element={<UserRoles />} />
          <Route exact path="/admin/settings/user-permissions" element={<UserPermissions />} />
          <Route exact path="/admin/settings/teams/list" element={<Teams />} />
          <Route exact path="/admin/settings/teams/create" element={<CreateTeam />} />
          <Route exact path="/admin/settings/teams/edit" element={<EditTeam />} />
          <Route exact path="/admin/settings/notification" element={<Notifications />} />
          <Route exact path="/admin/settings/aws" element={<Aws />} />
          <Route exact path="/admin/settings/smtp" element={<Smtp />} />
          <Route exact path="/admin/settings/puppeteer" element={<Puppeteer />} />


          <Route exact path="/admin/terms-of-use" element={<Terms />} />
          <Route exact path="/admin/privacy-policy" element={<PrivacyPolicies />} />
          <Route exact path="/admin/cookie-policy" element={<CookiePolicies />} />

          {/* No need for these pages */}
          {/* <Route exact path="/admin/roi-calculator/roi-compoments" element={<ROIComponents />} /> */}
          {/* <Route exact path="/admin/roi-calculator/roi-form" element={<ROIForm />} /> */}
          {/* <Route exact path="/admin/roi-calculator/roi-report" element={<ROIReport />} /> */}
          {/* <Route exact path="/admin/roi-calculator/roi-report-single" element={<ROISinglePage />} /> */}

          <Route exact path="/admin/roi/:id" element={<RoiUpdate />} />
          <Route exact path="/admin/roi" element={<OnBoarding />} />
          <Route exact path="/admin/roi-analytics" element={<ROIAnalytics />} />
          <Route exact path="/admin/roi/:id/calculation-logic" element={<RoiCalculation />} />
          <Route exact path="/admin/roi/:id/calculation-logic/add/:cid?" element={<RoiCalculationAdd />} />
          <Route exact path="/admin/roi/:id/custom-variable" element={<RoiCustomVariable />} />
          <Route exact path="/admin/roi/:id/custom-variable/add/:cid?" element={<RoiCustomVariableAdd />} />
          {/* <Route exact path="/admin/roi-onboarding/templates" element={<TemplateList />} /> */}
          <Route exact path="/admin/roi/create" element={<RoiCreate />} />
          {/* <Route exact path="/admin/roi/test/:id" element={<EditorComponent />} /> */}
          <Route exact path="/admin/not-found" element={<NotFound />} />


          <Route exact path="/admin/ducumentation/surveys/create-calculator" element={<CreateCalculator />} />
          <Route exact path="/admin/ducumentation/surveys/document-dashboard" element={<DocumentDashboard />} />
          <Route exact path="/admin/ducumentation/surveys/document-actionsinlist" element={<ActionInCalculatorList />} />
          <Route exact path="/admin/ducumentation/surveys/document-calculationLogic" element={<CalculationLogic />} />
          <Route exact path="/admin/ducumentation/surveys/document-customvariable" element={<CustomVariable />} />
          <Route exact path="/admin/ducumentation/settings/document-accountsetting" element={<DocumentAccountSetting />} />
          <Route exact path="/admin/ducumentation/settings/puppeteer-settings" element={<DocumentPuppeteerSettings />} />
          <Route exact path="/admin/ducumentation/settings/document-roles" element={<DocumentRoles />} />
          <Route exact path="/admin/ducumentation/settings/document-teams" element={<DocumentTeams />} />
          <Route exact path="/admin/ducumentation/settings/document-users" element={<DocumentUsers />} />
          <Route exact path="/admin/ducumentation/document-analytics" element={<DocumentAnalytics />} />

        </Routes>
      </PersistGate>

      {/* 
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <ToastContainer /> 
      */}

    </>

  );
};
export default App;